import { useSelector } from 'react-redux'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { FactSheet } from '../../order/factSheetReport'
import { factSheetTypes } from '../../order/factSheetReport/constants'

export const Content = () => {
  const userType = useSelector(selectUserType)
  const type =
    userType.userTypeId === USER_TYPE.LITE
      ? factSheetTypes.POPUP_LITE
      : factSheetTypes.POPUP_OTHERS

  return <FactSheet type={type} />
}
